import queryString from 'query-string';

import type { Parameter } from '../../cardsTest/cardsTest.types';

/** Filtering empty inputs and creates a query string for the test request. */
export const generateTestQueryString = (
  parameters: Dictionary<Parameter>,
): string => {
  const filtered = Object.entries(parameters).reduce(
    (acc, [_key, parameter]) => {
      if (parameter.id && parameter.value) {
        return {
          ...acc,
          [parameter.id]: parameter.value.trim(),
        };
      }
      return acc;
    },
    {},
  );

  const qs = queryString.stringify(filtered);
  return qs ? `?${qs}` : '';
};
